// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.3-next',
  revision: '89b286693',
  branch: 'next',
  date: 'Mon, 15 Jun 2026 14:08:58 GMT'
};